import { useEffect, useState } from "react";

const navLinks = [
  { href: "#guide", label: "使用指南" },
  { href: "#beginner", label: "新手入门" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
  { href: "#contact", label: "联系我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200 bg-background-50/90 shadow-soft backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <div className="container-x flex h-16 items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5" aria-label="笔笔漫画网首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 font-heading text-lg text-background-50">
            笔
          </span>
          <span className={`font-heading text-lg md:text-xl ${scrolled ? "text-foreground-950" : "text-foreground-900"}`}>
            笔笔漫画网
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors hover:bg-primary-100 hover:text-primary-700 ${
                scrolled ? "text-foreground-800" : "text-foreground-900"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            获取帮助
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-800 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-primary-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              获取帮助
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}